/**
 * Routes where the feedback banner must not mount (invoice form pages with a fixed bottom action bar).
 */
export const isFeedbackBannerExcludedRoute = (pathname: string): boolean => {
  if (pathname === '/invoices/new') {
    return true
  }

  // Edit invoice: /invoices/:id — exclude sub-routes such as /invoices/:id/send-email
  return /^\/invoices\/[^/]+$/.test(pathname) && pathname !== '/invoices/new'
}
